
// Libraries
import { Component, Vue, Prop, Watch } from "nuxt-property-decorator";
import { ButtonText } from "~/operations/messages";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);

// Components
import UserComment from "~/components/molecules/text/UserComment.vue";
import PartnerSortHeader from "~/components/molecules/nav/PartnerSortHeader.vue";
import { UserCommentsState } from "~/store/partnerUserComments";

type sortOptions = "bad" | "best" | "old" | "new";

@Component({
  components: {
    UserComment,
    PartnerSortHeader,
  },
})
export default class UserCommentsOrganism extends Vue {
  @Prop() businessCustomerId: string | string[];
  @Prop() partnerLogoUrl: string;
  @Prop() userComments: UserCommentsState;

  ButtonText = ButtonText;

  fetchPagesCount = 1;
  sortLoadToggle = false;

  sortByOption: sortOptions = "new";
  sortDesc = true;

  @Watch("sortByOption")
  onSortByOptionChange() {
    this.fetchPagesCount = 0;
    this.commentLength === 0
      ? (this.sortLoadToggle = false)
      : (this.sortLoadToggle = true);
    this.fetchUserComments();
  }

  @Watch("businessCustomerId")
  changeOfusinessCustomerId() {
    this.$store.commit("partnerUserComments/clearComments");
    this.fetchPagesCount = 0;
  }

  loadMorePartnerComments() {
    this.fetchPagesCount += 1;
    this.$store.dispatch("partnerUserComments/loadComments", {
      page: this.fetchPagesCount.toString(),
      body: {
        end: dayjs.utc().format(),
        start: dayjs.utc().subtract(1, "year").format(),
        sortBy: this.sortByOption,
        sortDesc: this.sortDesc,
        businessCustomerId: this.businessCustomerId,
      },
      clear: false,
    });
  }

  fetchUserComments() {
    this.fetchPagesCount += 1;
    this.$store.dispatch("partnerUserComments/loadComments", {
      page: this.fetchPagesCount.toString(),
      body: {
        end: dayjs.utc().format(),
        start: dayjs.utc().subtract(1, "year").format(),
        sortBy: this.sortByOption,
        sortDesc: this.sortDesc,
        businessCustomerId: this.businessCustomerId,
      },
      clear: true,
    });
  }

  get commentLength() {
    return this.userComments.data.length;
  }
}
